// extracted by mini-css-extract-plugin
module.exports = {"container":"index__container___3Gbjy","title":"index__title___Dx1lC","content":"index__content___1kKzL"};